<script>
import axios from 'axios';
import { InboundOrderPath } from '@/path.js';

    export default {
        props: ['type','obj'],
        data(){
            return {
                baseUrl : process.env.VUE_APP_API_BACKEND_URL,
                data : [],
                currentPage : 1,
                fields : ['batch_code','qty','name','warehouse','location']
            }
        },
        mounted(){
            this.getWarehouseLevelDetails();
        },
        watch : {
            currentPage(){
                this.getWarehouseLevelDetails();
            }
        },
        methods : {
            async getWarehouseLevelDetails(){
                try {
                    let res = await axios.get(this.baseUrl + InboundOrderPath.GET_BATCH_LEVEL_STOCK,{
                        params : {
                            type : this.type,
                            id : this.obj.item_id
                        }
                    });
                    if(res.data.status){
                        this.data = res.data.data;
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }
</script>

<template>
    <b-row>
        <div class="table-responsive">
            <b-table
                :key="data.key"
                :items="data.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="currentPage"
            >
            <template v-slot:cell(batch_code)="row">
                {{ row.item.b_code }}
            </template>
            </b-table>
        </div>
        <div class="row">
            <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination :key="data.key" v-model="currentPage" :total-rows="data.total" :per-page="data.per_page"></b-pagination>
                </ul>
                </div>
            </div>
        </div>
    </b-row>
</template>

<style>
    
</style>